export class CaseLegalForm {
  id:string;
      caseID: number;
      legalFormID:string;
      dateCreated: Date
      base30ImageString: string;
      firstName: string;
      lastName: string;
      last4SSN: string;
      agreeToTermsCheckbox1: boolean;
      agreeToTermsCheckbox2: boolean;


}
